import React, { Component } from 'react'
import { connect } from 'react-redux'
import LogoPayoff from '../../dist/images/logo-frankwatching-payoff.svg'
import { api } from '../../api'
import { menuItems } from '../../config/menu'
import SideBarMenu from './sidebarMenu'
import SideBarMenuBottom from './sidebarMenuBottom'

class AppSidebarComponent extends Component {

	constructor( props ) {
		super(props);

		this.signOut = this.signOut.bind( this );
	}

	signOut(e) {
		e.preventDefault();

		api.auth.signOutUser();
	}

	render() {

		// console.log( this.props );

		return (
			<div className="cell medium-3 align-self-stretch sidebar">
				<div className="sidebar__top">
					<img src={LogoPayoff} alt="Logo Frankwatching" />
				</div>
				<div className="sidebar__user">
					<img src={this.props.user.photoURL} className="sidebar__user__image" alt="" />
					<strong>{ this.props.user.displayName}</strong>
				</div>
				{/*<div>{ this.props.user.email }</div>*/}

				<SideBarMenu menuItems={menuItems} />

				<SideBarMenuBottom/>

			</div>

		)
	}
}

const mapStateToProps = ( state ) => {
	return {
		user: state.auth.user
	}
};

export default connect(mapStateToProps)(AppSidebarComponent)


// WEBPACK FOOTER //
// ./src/application/templates/sidebar.js